var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinWeWorkSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "-3 -3 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 12.1445,
    r: 12,
    fill: "white",
    stroke: "#002F1B",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25073 10.0993C7.51578 10.0993 7.74712 10.1085 7.95214 10.1459C8.24398 10.1972 8.49102 10.604 8.49102 10.8025C8.49102 10.9041 8.49102 11.0168 8.44669 11.1812C8.37466 11.4333 7.87965 12.3402 7.6737 12.6814C7.42574 12.2792 6.84207 11.1433 6.64028 10.7009C6.55254 10.5153 6.50822 10.3611 6.50822 10.2854C6.50822 10.1459 6.78527 10.0993 7.25073 10.0993ZM3.94313 10.0993C4.19063 10.1607 4.33563 10.2119 4.5388 10.5758C5.25407 11.8886 5.97026 13.3358 6.66706 14.7594C6.7548 14.8333 6.85731 14.8499 7.00553 14.8499C7.14868 14.8499 7.25027 14.8333 7.3417 14.7598C7.6737 14.1332 8.54966 12.4515 8.92738 11.7986C9.36698 12.6057 10.1238 14.0787 10.4309 14.7598C10.5158 14.8337 10.6211 14.8499 10.7647 14.8499C10.9102 14.8499 11.015 14.8333 11.0995 14.7598C11.7178 13.4072 12.3695 12.0702 13.0541 10.7499C13.2878 10.2854 13.3889 10.1607 13.8705 10.0711L14.0746 10.0351C14.191 9.91826 14.161 9.64444 14.0317 9.5918C13.7108 9.61719 13.3321 9.63012 12.9068 9.63012C12.543 9.63012 12.1957 9.61719 11.7127 9.5918C11.5668 9.64444 11.5668 9.94504 11.6559 10.0351L11.9016 10.0826C12.1523 10.1339 12.2668 10.1972 12.2668 10.2614C12.2668 10.3495 12.2225 10.5259 12.132 10.7499C11.9016 11.3331 11.673 11.9514 11.3188 12.6814C10.9993 12.0747 10.592 11.2574 10.3279 10.6515C10.242 10.4387 10.2125 10.3606 10.2125 10.2614C10.2125 10.1972 10.4143 10.1339 10.7518 10.0711L10.9688 10.0351C11.0741 9.98383 11.0852 9.60704 10.9254 9.5918C10.0656 9.61717 9.20535 9.62995 8.3451 9.63012H5.40045C4.78815 9.63012 4.3227 9.61719 3.72518 9.5918C3.57603 9.65506 3.57603 9.93212 3.67716 10.0351L3.94313 10.0993Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1214 10.0208C16.615 10.0208 16.8939 10.2956 16.8939 10.7125C16.8939 10.8391 16.8648 10.9665 16.7923 11.0025C16.6293 11.0912 16.3966 11.1147 16.193 11.1147H15.6545C15.1854 11.1147 14.9841 11.1055 14.9841 10.9268C14.9841 10.5223 15.5091 10.0203 16.1218 10.0203L16.1214 10.0208ZM16.1061 14.8351C16.9803 14.8351 18.0622 14.469 18.6583 13.3981C18.6583 13.1834 18.4371 13.0818 18.2787 13.1054C17.8848 13.6877 17.3289 13.7611 16.9221 13.7611C15.5673 13.7611 14.8654 12.8426 14.8654 11.8974C14.8654 11.6961 14.8959 11.6711 15.232 11.6711H18.028C18.4833 11.6711 18.5544 11.4948 18.5544 11.2556C18.5544 10.2836 17.7371 9.43945 16.2207 9.43945C14.4013 9.43945 13.0742 10.6756 13.0742 12.2645C13.0742 13.6382 14.1386 14.8351 16.1061 14.8351Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2,
    y: -2,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinWeWorkSelected);
export default __webpack_public_path__ + "static/media/pin_WeWork_selected.fba2645b0e697d5488668d80fcbd659d.svg";
export { ForwardRef as ReactComponent };